import { render, staticRenderFns } from "./bingtu.vue?vue&type=template&id=ad902024&scoped=true"
import script from "./bingtu.vue?vue&type=script&lang=js"
export * from "./bingtu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad902024",
  null
  
)

export default component.exports